import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { useDispatch } from "react-redux";
import { setCv } from "../store/auth/cv";

function AlmostThere() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = GetStorage.get("xAuthToken");

  const [error, setError] = useState("");
  const inputFileRef = useRef(null);

  const [file, setFile] = useState({});

  const onImageChange = (event) => {
    console.log("image==>", event.target.files[0]);
    setFile(event.target.files[0]);
    let img = event.target.files[0];

    const pictureToShow = URL.createObjectURL(img);
    // console.log("image==>", pictureToShow);

    dispatch(setCv(pictureToShow));

    onSubmit(img)
  };

  const onSubmit = async (values) => {
    var formData = new FormData();

    // formData.append("cv", file);
    formData.append("cv", values);

    http
      .put(`api/analyst/cv?token=${token}`, formData)
      .then((res) => {
        console.log("bank response ------->>>>", res.data);
        navigate("/areYouSure");
      })
      .catch((error) => {
        console.log("error in bank account", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification custom_hight">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">Almost there!</h1>
          <p className="mb_40 them_para text-center mx-auto text_limit">
            Set up your profile now... Upload your resume.
          </p>
          <div className="upload_img mb_30">
            {" "}
            {/* <input type="file" ref={inputFileRef} onChange={onImageChange} /> */}
            <h5>Upload CV</h5>
          </div>
          <h6 style={{ color: "red" }}>{error}</h6>
          <div className="btn_wraper mt-5">
          <div class="upload-btn-wrapper btn_wraper">
              <button class="them_btn">Browse</button>
              <input
                type="file"
                name="myfile"
                ref={inputFileRef}
                onChange={onImageChange}
              />{" "}
            </div>
            {/* <button
              type="button"
              className="them_btn mt_40 mb_30"
              onClick={onSubmit}
            >
              Continue
            </button>
            <button
              class="them_btn "
              onClick={() => navigate("/downloadSample")}
              style={{ marginLeft: 20 }}
            >
              Skip
            </button> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default AlmostThere;
